<template>
  <b-modal ref="modal" id="tfa-recovery-codes" centered hide-header hide-footer>
    <template v-if="step === 1">
      <h2>Generate new recovery codes</h2>
      <p>
        If you have lost access to your recovery codes, or run out of active
        codes, you can regenerate them here. Generating new codes will
        invalidate any existing codes.
      </p>
      <div class="d-flex mt-4 text-right">
        <b-button
          variant="secondary"
          class="px-4 mr-auto"
          @click="$refs.modal.hide()"
        >
          Cancel
        </b-button>
        <b-button variant="primary" class="px-4" @click="step1">
          Continue
        </b-button>
      </div>
    </template>

    <template v-else-if="step === 2">
      <RecoveryCodes :codes="codes" @close="$refs.modal.hide()" />
    </template>
  </b-modal>
</template>

<script>
import API from "@/api";
import RecoveryCodes from "./RecoveryCodes";

export default {
  components: { RecoveryCodes },

  data: () => ({
    codes: [],
    step: 1
  }),

  methods: {
    async step1() {
      const res = await API.generateRecoveryCodes();
      if (!res.success) return;
      this.codes = res.results.recovery_codes;
      this.step = 2;
    }
  }
};
</script>
